import { ModelApiService } from './BaseApiService'

export default class CandidateApiService extends ModelApiService {
  constructor() {
    super('candidate')
  }

  async getCandidateDetails(id) {
    return this.get(`${id}/details`)
  }

  getCandidateList(id) {
    return this.get(`CandidateList?ClientId=${id}`)
  }

  async getDisplayPic(id) {
    if (id && id >= 0) {
      return this.get(`profile-image/${id}`)
    }
  }
}
